module.exports = __webpack_public_path__ + "static/media/email.e7c024ec.svg";